<template>
  <div class="row f-row">
    <div class="col col-12" v-if="isSwitch">
      <table class="table table-sm table-borderless real_time_table">
        <thead class="table-headers text-center align-center thead">
          <tr>
            <th class="min_w">Switch</th>
            <th class="min_w">Last</th>
            <th class="min_w">Month/Year</th>
            <th class="min_w">Unit</th>
            <th class="min_w">Switch</th>
            <th class="min_w">Last</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(_, index) in skeletonTable.slice(0, 3)"
            v-bind:key="index"
          >
            <td>
              <div class="row f-row" style="text-align: left;">
                <div class="col col-11 ml-2">Future {{ index + 1 }}</div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-11">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td>
              <div class="row f-row" style="text-align: left;">
                <div class="col col-11 ml-2">Month/Year {{ index + 1 }}</div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-11">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td>
              <div class="row f-row" style="text-align: left;">
                <div class="col col-11 ml-2">Future {{ index + 1 }}</div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-11">
                  <Skeleton />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-12" v-else>
      <table class="table table-sm table-borderless real_time_table">
        <thead class="table-headers text-center align-center thead">
          <tr>
            <th class="min_w">Arbitrage</th>
            <th class="min_w">Curr 1</th>
            <th class="min_w">Curr 2</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(_, index) in skeletonTable.slice(0, 3)"
            v-bind:key="index"
          >
            <td>
              <div class="row f-row" style="text-align: left;">
                <div class="col col-11 ml-2">Future {{ index + 1 }}</div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-11">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-11">
                  <Skeleton />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getSkeletonTable } from "@/_core/_helpers/_helpers";
import Skeleton from "primevue/skeleton";

export default {
  name: "SkeletonSpotTable",
  components: {
    Skeleton
  },
  props: {
    isSwitch: { required: false, type: Boolean, default: true }
  },
  data() {
    return {
      skeletonTable: []
    };
  },
  created() {
    this.skeletonTable = getSkeletonTable();
  }
};
</script>

<style scoped>
.min_w {
  min-width: 60px;
}
</style>
